import { render, staticRenderFns } from "./wart.vue?vue&type=template&id=77980aa0&scoped=true&"
import script from "./wart.vue?vue&type=script&lang=js&"
export * from "./wart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77980aa0",
  null
  
)

export default component.exports